export default "__VITE_ASSET__DBgcKUvX__"